export enum SettlementPaymentStatusEnum {
    Niezaplacona = 1,
    ZaplataCzesciowa = 2,
    Zaplacona = 3,
    Nadplata = 4,
}
